import React from 'react'
import moment from 'moment'
import { useStoreState } from 'easy-peasy'
import { DayPickerSingleDateController } from 'react-dates'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import { IconButton } from '@workboard/wobo-ui'

import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'

import { getMoment } from '../../utils/dates'

const DatePicker = ({
  date,
  numberOfMonths = 2,
  onChange,
  onOutsideClick,
}) => {

  const { user } = useStoreState((state) => state.app)

  // Current Day highlighter
  const isDayHighlighted = (day) => {
    const isSelectedDate = date && date.isSame(day, 'day')

    return getMoment(user).isSame(day, 'day') && !isSelectedDate
  }

  // Create styled navigation icons for the range picker
  const renderNavPrevButton = ({ onClick, disabled }) => (
    <IconButton
      className="m-date-picker__prev-month"
      isDisabled={disabled}
      onClick={onClick}
    >
      <KeyboardArrowLeftIcon />
    </IconButton>
  )
  const renderNavNextButton = ({ onClick, disabled }) => (
    <IconButton
      className="m-date-picker__next-month"
      isDisabled={disabled}
      onClick={onClick}
    >
      <KeyboardArrowRightIcon />
    </IconButton>
  )

  // Adjust date picker layout for webex meeting sessions
  let className = 'm-date-picker'
  let adjustedNumberOfMonths = numberOfMonths
  if (window.webexApp) {
    className += ' webex'
    adjustedNumberOfMonths = 1
  }

  return (
    <div className={className}>
      <div style={{ height: 285 }}>
        <DayPickerSingleDateController
          date={date}
          initialVisibleMonth={() => date || getMoment(user)}
          noBorder
          hideKeyboardShortcutsPanel
          daySize={30}
          numberOfMonths={adjustedNumberOfMonths}
          isDayHighlighted={isDayHighlighted}
          renderNavPrevButton={renderNavPrevButton}
          renderNavNextButton={renderNavNextButton}
          onDateChange={onChange}
          onOutsideClick={onOutsideClick}
        />
      </div>
    </div>
  )
}

export default DatePicker
